/**
 * Helpers for downloading / sharing PDF blobs without exposing blob: URLs
 * in copyable or shareable href attributes.
 */

export function downloadBlobUrl(url, fileName) {
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
}

export async function blobUrlToPdfFile(url, fileName) {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`pdf_blob_fetch_failed_${res.status}`);
  const blob = await res.blob();
  return new File([blob], fileName, { type: blob.type || "application/pdf" });
}

export function canSharePdfFile(file) {
  if (typeof navigator === "undefined" || typeof navigator.share !== "function") {
    return false;
  }
  if (typeof navigator.canShare !== "function") {
    return false;
  }
  try {
    return navigator.canShare({ files: [file] });
  } catch {
    return false;
  }
}

/**
 * Share PDF file via Web Share API. Returns true if share sheet opened.
 * Returns false if file sharing is unsupported (caller should fall back / toast).
 */
export async function sharePdfFromBlobUrl(url, fileName) {
  const file = await blobUrlToPdfFile(url, fileName);
  if (!canSharePdfFile(file)) {
    return false;
  }
  await navigator.share({ files: [file], title: fileName });
  return true;
}
